"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadFonts = exports.TypekitFonts = exports.GoogleFonts = void 0;

var _lodash = _interopRequireDefault(require("lodash.union"));

var _lodash2 = _interopRequireDefault(require("lodash.filter"));

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _fonts = _interopRequireDefault(require("../config/fonts.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GoogleFonts = function GoogleFonts() {
  return (0, _lodash.default)( // text styler fonts
  (0, _lodash2.default)(_fonts.default, ['src', 'google']).map(function (f) {
    var font = f.font;

    if (f.weights && f.weights.length) {
      var weightsWithStyle = f.weights.map(function (weight) {
        if (f.isItalic) {
          return "".concat(weight, "i");
        }

        return weight;
      });
      font += ":".concat(weightsWithStyle.join(','));
    }

    font += ':all';
    return font;
  }));
};

exports.GoogleFonts = GoogleFonts;

var TypekitFonts = function TypekitFonts() {
  return _fonts.default.typekit;
};

exports.TypekitFonts = TypekitFonts;

var LoadFonts = function LoadFonts(extraFonts, timeout, logInactive) {
  // Do nothing, in case of SSR, in order to fix the window is undefined error
  if (typeof window === 'undefined') {
    return new Promise(function (resolve) {
      resolve();
    });
  }

  var WebFont = require('webfontloader');

  var additionalFonts = {};

  if (extraFonts && extraFonts.css && extraFonts.fonts && extraFonts.fonts.length > 0) {
    additionalFonts = {
      custom: {
        families: extraFonts.fonts.map(function (item) {
          var font = item.font,
              weight = item.weight;
          return "".concat(font, ":n").concat(weight / 100);
        }),
        urls: extraFonts.css
      }
    };
  }

  var config = {
    google: {
      families: GoogleFonts()
    },
    custom: {
      families: ['Neue Helvetica:n3', 'Neue Helvetica', 'Neue Helvetica:n9', 'Santeli Light', 'Wes FY', 'Wes FY:n5', 'Wes FY:n9'],
      urls: ['https://ak01-cdn.slidely.com/static/promo-videos/fonts/promo-fonts-v3.css?dv=1']
    },
    typekit: {
      id: 'nth1opl'
    }
  };
  return new Promise(function (resolve) {
    WebFont.load(_objectSpread(_objectSpread({}, (0, _deepmerge.default)(additionalFonts, config)), {}, {
      loading: function loading() {
        console.log('LOADING fonts');
        console.log('extraFonts', extraFonts);
      },
      active: function active() {
        console.log('All font was loaded');
        resolve();
      },
      fontinactive: function fontinactive(familyName, fvd) {
        if (logInactive) {
          console.log('fontinactive', familyName, fvd);
        }
      },
      timeout: timeout || 6000
    }));
  });
};

exports.LoadFonts = LoadFonts;